import { BRAND_MARKS } from "./BrandIcons";

// A slow, looping logo strip. Two copies of the list slide left so the seam
// is invisible. Pauses on hover; honors prefers-reduced-motion via the CSS.
export function IntegrationMarquee() {
  return (
    <div
      className="ss-marquee group relative w-full overflow-hidden select-none"
      aria-label="Integrations Sidestack supports"
    >
      {/* Soft fade on the edges so logos appear / disappear gently. */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10 bg-gradient-to-r from-bg to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10 bg-gradient-to-l from-bg to-transparent" />

      <div className="ss-marquee-track flex w-max gap-12 py-2">
        {[0, 1].map((copy) => (
          <ul
            key={copy}
            aria-hidden={copy === 1}
            // The second copy exists only to make the slide loop seamless.
            // When motion is off, hide it so users see one clean static row
            // instead of a duplicated list clipped at the fade edge.
            className={
              "flex shrink-0 items-center gap-12 " +
              (copy === 1 ? "motion-reduce:hidden" : "")
            }
          >
            {BRAND_MARKS.map(({ name, Icon }) => (
              <li
                key={`${copy}-${name}`}
                className="flex items-center gap-2.5 text-td-3 transition-colors duration-200 hover:text-td-1"
              >
                <Icon size={20} />
                <span className="font-mono text-[11px] uppercase tracking-[0.18em]">
                  {name}
                </span>
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  );
}
